module.exports = __webpack_public_path__ + "img/2-4.19f2b1ce.jpg";